import http from "./http";

class InboxService {
  // ============= NOTIFICATIONS =============

  async getNotifications(params = {}) {
    const res = await http.get("/notifications", { params });
    return res.data;
  }

  async getUnreadCount() {
    const res = await http.get("/notifications/unread-count");
    return res.data;
  }

  async markNotificationsRead(notificationIds) {
    const res = await http.post("/notifications/mark-read", {
      notification_ids: notificationIds,
    });
    return res.data;
  }

  async markAllNotificationsRead() {
    const res = await http.post("/notifications/mark-all-read");
    return res.data;
  }

  async deleteNotification(notificationId) {
    const res = await http.delete(`/notifications/${notificationId}`);
    return res.data;
  }

  // ============= INBOX THREADS =============

  async getThreads(params = {}) {
    const res = await http.get("/inbox/threads", { params });
    return res.data;
  }

  async createThread(data) {
    const res = await http.post("/inbox/threads", data);
    return res.data;
  }

  async getThread(threadId) {
    const res = await http.get(`/inbox/threads/${threadId}`);
    return res.data;
  }

  async addMessage(threadId, body, attachmentsJson = null) {
    const res = await http.post(`/inbox/threads/${threadId}/messages`, {
      body,
      attachments_json: attachmentsJson,
    });
    return res.data;
  }

  async closeThread(threadId) {
    const res = await http.post(`/inbox/threads/${threadId}/close`);
    return res.data;
  }

  // ============= OUTBOX (Admin) =============

  async getOutboxMessages(params = {}) {
    const res = await http.get("/inbox/outbox", { params });
    return res.data;
  }

  async createOutboxMessage(data) {
    const res = await http.post("/inbox/outbox", data);
    return res.data;
  }

  async retryOutboxMessage(messageId) {
    const res = await http.post(`/inbox/outbox/${messageId}/retry`);
    return res.data;
  }
}

export default new InboxService();
